/**
 * Under a card's dropdown menus, which are outlined: one soft, low layer instead of MUI's elevation 8, which
 * read as heavy next to the survey editor's popups. Same value as the variable picker's floating surfaces.
 */
export const FLOATING_SHADOW = '0 4px 16px rgba(15, 23, 42, 0.08)';

export const CONTENT_MAX_WIDTH = 1440;
export const CARD_GAP = {xs: 3, md: 4} as const;

/* ---------- Bar geometry ---------- */
export const BAR_HEIGHT = 12;
export const COMPARE_BAR_HEIGHT = 6;
export const BAR_RADIUS = 3;
export const MARKER_WIDTH = 3;
export const MARKER_OVERHANG = 4;
export const COMPARE_TICK_WIDTH = 2;
export const BAR_DRAW_DURATION = 1400;
export const MARKER_FADE_DURATION = 450;
export const MARKER_FADE_DELAY = BAR_DRAW_DURATION * 0.55;

